import { render, staticRenderFns } from "./SocialTwo.vue?vue&type=template&id=8e32758a&scoped=true&"
import script from "./SocialTwo.vue?vue&type=script&lang=js&"
export * from "./SocialTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e32758a",
  null
  
)

export default component.exports